export default __webpack_public_path__ + "static/media/our-services-edu-nursery-01.487c9059.jpg";